// extracted by mini-css-extract-plugin
module.exports = {"PageLoading":"PageLoading_PageLoading__qpQ5y"};